import { useRouter } from "next/router";

const NavBar = () => {
    const router = useRouter();

    const handlerEventHome = () => {
        router.push("/");
    };

    return (
        <nav className="navbar navbar-expand-lg header-container">
            <div className="container-fluid">
                <div className="navbar-brand" onClick={handlerEventHome}>
                    <img src="/artesanato_logo.png" alt="Logo"
                    className="d-inline-block align-text-top brand-image-navbar" />
                </div>
                {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button> */}
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto">
                        {/* <li className="nav-item" onClick={handlerEventHome}>
                            <span className={`nav-link ${route === "home" && "active"}`}>{t.navbar.home.title}</span>
                        </li> */}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;